import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FeedbackIcon(props: IconProps) {
    return <Icon {...props} iconKey={"feedback"}/>
}
